<zuper-drawer class="border-l border-gray-300 shadow-none non-job-event-details-drawer" [name]="drawerName"
    [mode]="'over'" [position]="'right'" [transparentOverlay]="false" (openedChanged)="drawerOpenedChanged($event)"
    [hideOnClickOutside]="false" [fixed]="true">
    <div class="drawer-content w-full">
        <!-- Progress bar -->
        <div class="h-1 w-full" *ngIf="isLoading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>

        <!-- Header -->
        <div class="flex flex-col w-full primary-font text-gray-700 font-normal">
            <div class="w-full px-5 py-2 bg-accent-100 dark:bg-accent-700 z-0 flex">
                <div class="mr-2 w-3/4 flex flex-col justify-center">
                    <div class="flex items-center space-x-2">
                        <i class="ti ti-calendar text-3xl font-medium"></i>
                        <h3 class="text-xl font-bold text-gray-900 truncate">
                            {{nonJobEventDetails?.event_name || ''}}</h3>
                    </div>
                </div>
                <div class="flex items-center justify-end max-w-3xl ml-auto">
                    <div class="my-3 mr-2 ml-auto" *ngIf="accessControl?.edit || accessControl?.delete">
                        <button mat-icon-button [matMenuTriggerFor]="!isLoading && !isDeleted && moreActionsMenu">
                            <em class="ti ti-dots icon-size-7 text-gray-500"></em>
                        </button>
                    </div>
                    <button mat-icon-button matTooltip="{{'close.text' | translate}}" matTooltipPosition="above"
                        tabindex="0" (click)="closeDrawer()">
                        <em class="ti ti-x icon-size-7 text-gray-500"></em>
                    </button>
                    <mat-menu #moreActionsMenu="matMenu">
                        <a mat-menu-item class="primary-font text-base h-10 text-gray-700"
                            *ngIf="options?.actions?.edit && accessControl?.edit" (click)="editNonJobEvent()">
                            <em class="text-xl ti ti-pencil ml-1 mr-2.5"></em>
                            <span> {{'edit' | translate}}</span>
                        </a>
                        <a mat-menu-item class="primary-font text-base h-10 text-red-700"
                            *ngIf="options?.actions?.delete && accessControl?.delete" (click)="deleteNonJobEvent()">
                            <em class="text-xl ti ti-trash ml-1 mr-2.5"></em>
                            <span>
                                {{'delete.text' | translate}}</span>
                        </a>
                    </mat-menu>
                </div>
            </div>
        </div>

        <!-- Non job event details -->
        <div class="main-container primary-font text-gray-700 text-base font-normal bg-white zuper-scrollbar p-6 px-4"
            *ngIf="!isLoading && !isDeleted">
            <div class="flex flex-col space-y-6">
                <!-- Event Name -->
                <div class="grid grid-cols-6 gap-4">
                    <div class="col-span-2 break-words text-gray-500">
                        <span>{{"non_job_event.create.name" | translate}}</span>
                    </div>
                    <div class="col-span-4 break-words">
                        <div class="flex items-center space-x-1.5">
                            <i class="ti ti-repeat text-2xl text-blue" *ngIf="nonJobEventDetails?.is_recurrence" title="{{'text.recurrence_event' | translate}}"></i>
                            <span class="text-break">{{nonJobEventDetails?.event_name || ''}}</span>
                        </div>
                    </div>
                </div>

                <!-- Category -->
                <div class="grid grid-cols-6 gap-4">
                    <div class="col-span-2 break-words text-gray-500">
                        <span>{{"category.text" | translate}}</span>
                    </div>
                    <div class="col-span-4 break-words">
                        <div class="flex items-center space-x-2">
                            <div class="w-3.5 h-3.5 mb-1 rounded-sm"
                                [style.background]="nonJobEventDetails?.categoryColor"></div>
                            <span>{{nonJobEventDetails?.event_category?.category_name}}</span>
                        </div>
                    </div>
                </div>

                <!-- Attendees -->
                <div class="grid grid-cols-6 gap-4">
                    <div class="col-span-2 break-words text-gray-500">
                        <span>{{"non_job_event.create.attendees" | translate}}</span>
                    </div>
                    <div class="col-span-4 break-words">
                        <div class="text-base sm:col-span-2 min-w-0 flex flex-col w-full -mt-1.5 divide-y
                            divide-gray-200" *ngIf="nonJobEventDetails?.assigned_to">
                            <ng-container *ngFor="let assignedTo of nonJobEventDetails?.assigned_to">
                                <div class="flex items-center py-1.5" *ngIf="assignedTo?.user">
                                    <img *ngIf="assignedTo?.hasValidProfilePicture" class="relative rounded-md mr-2"
                                        [ngClass]="showUserTeamAndRole?'h-10 w-10': 'h-8 w-8'"
                                        src="{{assignedTo?.user?.profile_picture}}"
                                        alt="{{assignedTo?.user?.first_name}} {{assignedTo?.user?.last_name ?? ''}}"
                                        title="{{assignedTo?.user?.first_name}} {{assignedTo?.user?.last_name ?? ''}}">
                                    <div *ngIf="!assignedTo?.hasValidProfilePicture"
                                        matTooltip="{{assignedTo?.user?.first_name}} {{assignedTo?.user?.last_name ?? ''}}"
                                        class="flex flex-shrink-0 bg-gray-200 rounded-md items-center text-base justify-center mr-2"
                                        [ngClass]="showUserTeamAndRole?'h-10 w-10': 'h-8 w-8'">
                                        {{assignedTo?.user?.first_name[0]}}
                                    </div>
                                    <div class="w-2/3 truncate">
                                        <p class="text-base"
                                            matTooltip="{{assignedTo?.user?.first_name}} {{assignedTo?.user?.last_name ?? ''}}">
                                            {{assignedTo?.user?.first_name ?? ''}} {{assignedTo?.user?.last_name ?? ''}}
                                        </p>
                                        <p class="text-md" *ngIf="assignedTo.team || assignedTo?.user?.role">
                                            <span class="pr-2"
                                                *ngIf="assignedTo?.user?.role">{{assignedTo?.user?.role?.role_name}}</span>
                                            <span class="border-l border-gray-400 pl-2"
                                                *ngIf="assignedTo.team">{{assignedTo.team?.team_name}}</span>
                                        </p>
                                    </div>
                                    <div class="flex ml-auto items-center space-x-2">
                                        <a href="mailto:{{assignedTo?.user?.email}}" target="_blank"
                                            matTooltip="{{'email' | translate}}"
                                            class="flex flex-shrink-0 hover:bg-gray-200 rounded-full items-center justify-center h-8 w-8 cursor-pointer"
                                            *ngIf="assignedTo?.user?.email">
                                            <em class="ti ti-mail text-xl"></em>
                                        </a>
                                        <a href="tel:{{assignedTo?.user?.mobile_phone_number || assignedTo?.user?.work_phone_number || assignedTo?.user?.home_phone_number}}"
                                            matTooltip="{{'text.contact' | translate}}" target="_blank"
                                            class="flex flex-shrink-0 hover:bg-gray-200 rounded-full items-center justify-center h-8 w-8 cursor-pointer"
                                            *ngIf="assignedTo?.user?.mobile_phone_number || assignedTo?.user?.work_phone_number || assignedTo?.user?.home_phone_number">
                                            <em class="ti ti-phone text-xl"></em>
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <span *ngIf="!nonJobEventDetails?.assigned_to?.length">---</span>
                    </div>
                </div>

                <!-- Event Address -->
                <div class="grid grid-cols-6 gap-4">
                    <div class="col-span-2 break-words text-gray-500">
                        <span>{{"non_job_event.create.event_address" | translate}}</span>
                    </div>
                    <div class="col-span-4 break-words">
                        <div class="flex items-start space-x-2" *ngIf="nonJobEventDetails?.eventAddress">
                            <i class="ti ti-map text-2xl"></i>
                            <span>{{nonJobEventDetails?.eventAddress}}</span>
                        </div>
                        <span *ngIf="!nonJobEventDetails?.eventAddress">---</span>
                    </div>
                </div>

                <!-- Event Schedule -->
                <div class="grid grid-cols-6 gap-4">
                    <div class="col-span-2 break-words text-gray-500">
                        <span>{{"text.scheduled_on" | translate}}</span>
                    </div>
                    <div class="col-span-4 break-words">
                        <div class="flex flex-col space-y-1">
                            <div class="flex space-x-2" title="{{timezoneDisplayName}}">
                                <i class="ti ti-calendar text-2xl" style="vertical-align: middle;"></i>
                                <span>
                                    {{nonJobEventDetails?.startEndDateTime[0]}}
                                    <i class="ti ti-arrow-right text-2xl" style="vertical-align: middle;"></i>
                                    {{nonJobEventDetails?.startEndDateTime[1]}} {{timezoneCode || ''}}
                                </span>
                            </div>
                            <div class="flex space-x-2 ml-7" *ngIf="nonJobEventDetails?.timezone" title="{{nonJobEventDetails?.timezoneDisplayName}}">
                                <span>
                                    {{ nonJobEventDetails?.timezoneBasedStartEndDateTime[0] }}
                                    <i class="ti ti-arrow-right text-2xl" style="vertical-align: middle;"></i>
                                    {{ nonJobEventDetails?.timezoneBasedStartEndDateTime[1] }} {{ nonJobEventDetails?.timezoneCode || '' }}
                                </span>
                            </div>
                        </div>
                        <div class="flex items-start space-x-1.5 mt-2" *ngIf="nonJobEventDetails?.is_recurrence && nonJobEventDetails?.recurrenceText">
                            <i class="ti ti-repeat text-2xl text-blue" title="{{'text.recurrence_event' | translate}}"></i>
                            <span>{{'text.repeats' | translate}} {{nonJobEventDetails?.recurrenceText || ''}}</span>
                        </div>
                    </div>
                </div>

                <!-- Availability -->
                <div class="grid grid-cols-6 gap-4">
                    <div class="col-span-2 break-words text-gray-500">
                        <span>{{"non_job_event.create.availability" | translate}}</span>
                    </div>
                    <div class="col-span-4 break-words">
                        <div class="flex items-center space-x-2">
                            <div class="w-2 h-5" [ngStyle]="nonJobEventDetails?.is_available 
                            ? {
                                'background': 'linear-gradient(135deg, ' + nonJobEventDetails?.categoryColor + ' 25%, #ffffff 25%, #ffffff 50%, ' + nonJobEventDetails?.categoryColor + ' 50%, ' + nonJobEventDetails?.categoryColor + ' 75%, #ffffff 75%, #ffffff 100%)',
                                'background-size': '8px 8px'
                              }
                            : {
                                'background': nonJobEventDetails?.categoryColor
                              }"></div>
                            <span>{{(nonJobEventDetails?.is_available ? 'non_job_event.create.availability.free':
                                'non_job_event.create.availability.busy') | translate}} </span>
                        </div>
                    </div>
                </div>

                <!-- Description -->
                <div class="grid grid-cols-6 gap-4">
                    <div class="col-span-2 break-words text-gray-500">
                        <span>{{"non_job_event.create.description" | translate}}</span>
                    </div>
                    <div class="col-span-4 break-words">
                        <div *ngIf="nonJobEventDetails?.event_description" class="tinymce-text-inner-html"
                            [innerHTML]="nonJobEventDetails?.event_description | safeHtml: false"></div>
                        <span *ngIf="!nonJobEventDetails?.event_description">---</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Non Job event not found -->
        <div class="w-full h-3/4 flex items-center justify-center" *ngIf="!isLoading && isDeleted">
            <span class="font-medium">{{'non_job_event.not_found' | translate}}</span>
        </div>
    </div>
</zuper-drawer>